<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>反算管理</el-breadcrumb-item>
			<el-breadcrumb-item>反算规则</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-input size="small"  @keyup.enter.native="search" v-model="formInline.priceName" placeholder="名称"></el-input>
			</el-form-item>
      <el-form-item label="选择类型">
      	<el-select v-model="formInline.powerType"  size="small"  placeholder="请选择" @change="changeType" >
      	  <el-option label="电" :value="15"></el-option>
      	  <el-option label="水" :value="16"></el-option>
      	</el-select>
      </el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<!-- <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
				<prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="rule:add" @click="handleEdit()" label="添加" />

			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
			<el-table-column type="index" width="60" label="序号">
			</el-table-column>
			<el-table-column prop="priceName" label="名称"   >
			</el-table-column>


			<el-table-column prop="powerType" label="类型"  >
        <template slot-scope="scope">
          <span v-if="scope.row.powerType == 15">电</span>
          <span v-if="scope.row.powerType == 16">水</span>
        </template>
			</el-table-column>
      <el-table-column prop="price" label="反算单价(元)"  >

			</el-table-column>

			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button size="mini" type="warning" @click="handleSet(scope.$index, scope.row)">设置</el-button>
					<el-button size="mini" type="danger"  @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>


		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible"  width="30%">
			<el-form label-width="68px" :model="editForm" :rules="rules" ref="editForm" style="padding: 0 30px;">
				<el-form-item label="名称" prop="priceName">
					<el-input size="small" v-model="editForm.priceName" auto-complete="off" placeholder="请输入名称"></el-input>
				</el-form-item>



        <el-form-item label="类型" prop="">
        	<el-select v-model="editForm.powerType"  size="small"  placeholder="请选择" style="width:100%">
        	  <el-option label="电" :value="15"></el-option>
            <el-option label="水" :value="16"></el-option>
        	</el-select>
        </el-form-item>
        <el-form-item label="反算单价" prop="price">
        	<el-input size="small" v-model="editForm.price" auto-complete="off" placeholder="请输入反算单价"></el-input>
        </el-form-item>
        <el-form-item label="月份" prop="month">
        	<el-date-picker value-format="yyyy-MM"  style="width:100%" size="small"  v-model="editForm.month" type="month"  placeholder="选择月"></el-date-picker>
        </el-form-item>



			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="editFormVisible = false">取消</el-button>
				<el-button size="small" :loading="loadingSave" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="绑定计量点" :visible.sync="setFormVisible" width="45%" :close-on-click-modal="false">

			<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="getMeterForNoBind">添加</el-button>
			<el-button type="danger" size="small" style="margin-bottom: 10px;" @click="delMeter"  :disabled="!tempDelMeterList.length" >删除</el-button>
			<div style="line-height: 30px;">当前绑定的计量点</div>
			<el-table :header-cell-style="this.$store.state.headerCss"  size="small" :data="selectList" height="500px" border  @selection-change="getDelMeterIds">
				<el-table-column type="selection"></el-table-column>
				<el-table-column label="id" prop="id" width="100"></el-table-column>
				<el-table-column label="计量点名称" prop="meterPointName" sortable></el-table-column>
				<el-table-column label="计量点通迅地址" prop="meterPoint"></el-table-column>

			</el-table>
			<div style="line-height: 40px;">共计:{{selectList.length}}</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='setFormVisible = false'>取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button>
			</div>
		</el-dialog>

    <!-- 添加计量点界面 -->
    <el-dialog :visible.sync="addFormVisible" width="60%" @click='addFormVisible = false' title="选择计量点" :close-on-click-modal="false">

      <el-form  :inline="true">
        <el-form-item v-if="user.username == 'admin'" label="部门">
          <el-select v-model="depId"   placeholder="请选择"  size="small" @change="changeDept">
             <el-option
               v-for="item in deptData"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
        </el-form-item>
        <el-form-item  label="集中器">
          <el-select v-model="terIds"  style="width: 300px;"  clearable multiple collapse-tags   placeholder="请选择"  size="small">
             <el-option
               v-for="item in terDatas"
               :key="item.id"
               :label="item.terminalName"
               :value="item.id">
             </el-option>
           </el-select>
        </el-form-item>
        <el-form-item >
          <el-input size="small" v-model="meterName" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="mSearch">搜索</el-button>
        </el-form-item>
      </el-form>

    	<el-table size="small" :data="meterList" height="500px" border  @selection-change="getAddMeterIds" ref='bindTable'
    	 v-loading="loadMeter" :header-cell-style="this.$store.state.headerCss">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column type="index" width="80"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
    		<el-table-column label="计量点通迅地址" prop="meterPoint" width="200"></el-table-column>

    	</el-table>
      <el-pagination

          @size-change="handleSizeChange"
         layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          background
          :page-size="pageForm.pageSize"
          :current-page="pageForm.currentPage"
          :page-sizes="[ 50,100,200,300,500]"
          style="margin-top: 20px;"
           @current-change="handleCurrentChange"
      >
      </el-pagination>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='addFormVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="addMeters()">确认</el-button>
    	</div>
    </el-dialog>

    <!-- 添加计量点界面 -->
    <el-dialog :visible.sync="showBindMeter" width="600px"  title="信息" :close-on-click-modal="false">

      <div style="max-height: 500px; overflow: auto;">
        <p style="border-bottom: 1px solid #f4f4f4; padding: 4px 0;" v-for="item in nmsg">{{item}}</p>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='showBindMeter = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="bindMeter">继续保存</el-button>
    	</div>
    </el-dialog>


	</div>
</template>
<script>

	import PremsButton from "@/views/permission/PreButtom";
	import {
		mapState
	} from 'vuex'
	import {
		addInverseRule,
    getInverseRules,
    findAllMeterInfoByInverPriceIds,/* 修改的接口 */
    checkPriceBindMeterInfo,
    priceBindMeterInfo,
    updateInverseRule,
    deleteInverseRule
	} from '../../api/payMG.js'   
  import { getDepartmentTerminalInfoLis} from '../../api/energyMG'
	export default {
		data() {
			var checkPrice = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('水价不能为空'));
				}
				setTimeout(() => {
					if (value <= 0) {
						callback(new Error('水价不能小于或者等于0'));
					} else {
						callback();
					}
				}, 1000);
			};
			return {
				formInline: {
					priceName: '',
          powerType:15,

				},
        showBindMeter:false,
        loadMeter:false,
        totalCount:0,
        terDatas:[],
        user:{},
        depId:"",
				editForm: {
          priceName:"",
          powerType:15,
          price:"",

          month:''
				},
        nmsg:[],
        terIds:[],
        meterName:"",
        deptData:[],
        editFormVisible:false,
        setFormVisible:false,
				title: '添加',
				dataList: [],
        tempDelMeterList:[],
        pageForm:{
          currentPage:1,
          pageSize:50
        },
        loadingSave:false,
        meterList:[],
        addFormVisible:false,
				loading: false,
				setLoading: false,
        selectList:[],
				rules: {

					priceName: [{
						required: true,
						message: '请输入水价名称',
						trigger: 'blur'
					}],
					price: [{
						validator: checkPrice,
						trigger: 'blur'
					}]

				},
			}
		},


		created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
			this.getdata();
      this.getJzData()


		},

		computed: {
			tables() {
				let search = this.searchDatas
				if (search) {
					return this.MeterInfoList.filter(data => {
						return Object.keys(data).some(key => {
							return String(data[key]).toLowerCase().indexOf(search) > -1
						})
					})
				}
				return this.MeterInfoList
			},
			...mapState({
				energyConfig: 'energyConfig'
			})
		},
		methods: {
      changeDept(e){

        this.terIds = []

        this.terIds = this.deptData.filter(item => item.id == e)[0].terminalInfo.map(item => item.id)
        this.terDatas = this.deptData.filter(item => item.id == e)[0].terminalInfo

        this.pageForm.currentPage = 1
        this.pageForm.pageSize = 50
        this.getMeterInfoList()
      },



      handleSizeChange(val){

        this.pageForm.pageSize = val
        this.getMeterInfoList();
      },

      handleCurrentChange(e) {

      	this.pageForm.currentPage = e
      	this.getMeterInfoList();
      },

      //获取部门信息
      getJzData:function(){
        this.loading = true
        getDepartmentTerminalInfoLis().then(res => {

          if(res.status == 1){
            this.deptData = res.data.menuDepList
            this.depId = res.data.menuDepList[0].id
            this.terDatas = res.data.menuDepList[0].terminalInfo
            this.terIds = res.data.menuDepList[0].terminalInfo.map(item => item.id)

          }
          else{
            this.$message.error(res.msg)
          }
        })
      },






			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata(this.formInline)
			},

      changeType(e){
        this.editForm.powerType = e
        this.getdata()
      },
			// 搜索事件
			search() {
				this.getdata()
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'
					this.editForm.id = row.id
          this.editForm.month = row.month
          this.editForm.price = row.price
          this.editForm.powerType =  parseInt(row.powerType)
          this.editForm.priceName = row.priceName
				} else {
					this.title = '添加'
					this.editForm.id = ""
          this.editForm.month = ''
          this.editForm.price = ''
          this.editForm.priceName = ''
				}
			},

			//设置弹窗
			handleSet(index, row) {
				this.setFormVisible = true
				this.curPriceId = row.id
				this.selectDatas = []
				this.selectDatas = row.meterInfoVoList.map(item => item.id)
				this.selectList = row.meterInfoVoList
			},
      getMeterForNoBind() {
        this.addFormVisible = true
        this.terIds = this.deptData.filter(item => item.id == this.depId)[0].terminalInfo.map(item => item.id)
        this.pageForm.currentPage = 1
        this.getMeterInfoList()
      },
      getDelMeterIds(e){
      	this.tempDelMeterList = e.map(item => item.id)
      },
      delMeter(e){

      	let arr = []
      	this.selectList.forEach(item =>{
      		console.log(item.id)
      		if (!(this.tempDelMeterList.indexOf(item.id) > -1)) {
      			arr.push(item)
      		}

      	})
      	this.selectList = arr
      },


			setChoisMeter(row) {
				let tempArr = []
				this.$nextTick(() => {
					this.$refs.bindTable.clearSelection(); //清除上一次除勾选项

					row.meterInfoVoList.forEach(item => {
						this.MeterInfoList.forEach((sitem, idx) => {
							if (item.id == sitem.id) {
								this.$refs.bindTable.toggleRowSelection(this.MeterInfoList[idx], true)
							}
						})
					})

				})
			},




			// 编辑、添加提交方法
			submitForm(editData) {

				this.$refs[editData].validate(valid => {
					if (valid) {
						if (this.title == '添加') {
							this.add();
						} else {
							this.update();
						}

					}
				})
			},



			getdata() {
				this.loading = true
				getInverseRules(this.formInline).then(res => {
						this.loading = false
						if (res.status == 1) {
							this.dataList = res.data
							// 分页赋值
							// this.pageparm.currentPage = this.formInline.currentPage
							// this.pageparm.pageSize = this.formInline.pageSize
							// this.pageparm.total = res.data.totalCount

						} else {
              this.loading = false
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.loading = false
						this.$message.error('获取数据失败，请稍后再试！')
					})
			},
			add() {

        this.loadingSave = true
				addInverseRule(this.editForm)
					.then(res => {
						this.loadingSave = false
						if (res.status == 1) {
							this.getdata(this.formInline)
              this.editFormVisible = false
							this.$message({
								type: 'success',
								message: '添加成功！'
							})
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					})

			},
			update() {
        this.loadingSave = true
				updateInverseRule(this.editForm)
					.then(res => {
						this.loadingSave = false
						if (res.status == 1) {
              this.editFormVisible = false
							this.getdata(this.formInline)
							this.$message({
								type: 'success',
								message: '操作成功！'
							})
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					})

			},
			// 删除
			deleteInfo(index, row) {
				this.$confirm('确定要删除吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						// 删除
						deleteInverseRule({
								id: row.id
							})
							.then(res => {
								if (res.status == 1) {
									this.$message({
										type: 'success',
										message: '已删除!'
									})
									this.getdata(this.formInline)
								} else {
									this.$message({
										type: 'error',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.loading = false
								this.$message.error('删除失败，请稍后再试！')
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除！'
						})
					})
			},


      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterName: this.meterName,
      		energyType:this.formInline.powerType,
      		priceId:this.curPriceId,
          terInfoIds:this.terIds.join('-'),
          currentPage: this.pageForm.currentPage,
          pageSize: this.pageForm.pageSize

      	}
      	findAllMeterInfoByInverPriceIds(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {

      			this.MeterInfoList = res.data
            this.meterList = res.data.data
            this.totalCount = res.data.totalCount
      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})

      },
      getAddMeterIds(e){
      	this.tempAddMeterList = e
      },

      addMeters(){
      	let arr = this.selectList.concat(this.tempAddMeterList)
      //	this.selectList = Array.from(new Set(arr))
        let find = []
        arr.forEach(item => {
          if(!find.find(e => e.id == item.id)){
            find.push(item)
          }
        })
       this.selectList = find








        console.log(this.selectList)
      	this.addFormVisible = false
      	this.tempAddMeterList = []

      	this.$refs.bindTable.clearSelection();

      },
      mSearch(){
        this.pageForm.currentPage = 1
        this.getMeterInfoList()
      },

      subBindMeter() {
      	let currMeterIds = this.selectList.map(item => item.id).join('-')
      	let param = {
      		priceId: this.curPriceId,
      		meterInfoIds: currMeterIds
      	}
      	//检查计量点是否已经绑定了其他价格
      	checkPriceBindMeterInfo(param).then(res => {
      		if (res.status == 1) {
      			this.bindMeter(param)
      		} else {
            this.nmsg = res.msg.split(',')
            this.showBindMeter = true
      			// this.$confirm(nmsg, '信息', {
      			// 	confirmButtonText: '确定',
      			// 	cancelButtonText: '取消',
      			// 	type: 'warning'
      			// }).then(() => {
      			// 	this.bindMeter(param)
      			// })
      		}
      	})
      },
      bindMeter() {
      	this.setLoading = true
        let currMeterIds = this.selectList.map(item => item.id).join('-')
        let param  = {
          priceId: this.curPriceId,
          meterInfoIds: currMeterIds
        }
      	priceBindMeterInfo(param)
      		.then(res => {
      			this.setLoading = false
      			this.setFormVisible = false

      			if (res.status == 1) {
      				this.$message({
      					type: 'success',
      					message: '操作成功！'
      				})
              this.showBindMeter = false
      				this.getdata()
      				// this.$store.dispatch('getSendMsg')
      				//this.meterPointName = ""

      			} else {
      				this.$message({
      					type: 'info',
      					message: res.msg
      				})
      			}
      		})
      		.catch(err => {
      			this.setFormVisible = false
      			this.setLoading = false
      			this.$message.error('操作失败，请稍后再试！')
      		})
      },


		},
		components: {

			PremsButton
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/prepayment/fsRule.vue